import React from 'react'
import {Col, Row} from 'react-bootstrap'

import BizLocationSelector from '../../component/BizLocation/BizLocationSelector'
import {DateRangeSelector} from '../../component/Date/DateRangeSelector'
import ProductTypeSelector from '../../productType/component/ProductTypeSelector'
import ReadpointSelector from '../../readpoint/component/ReadpointSelector'
import {dayMonthYearAtTimeWithSeconds} from '../../utils/dates'
import moment from "moment/moment";

class MovedProductsGrid {

  title = "Produtos movimentados"

  customFilters = {startDate: moment().subtract(6, 'days').toDate(), endDate: new Date()};

  exportNewPage = true
  showPdfButton = false
  showNewButton = false

  defaultSort = 'date';

  columns = [
    {
      Header: "Referencia",
      accessor: 'productType.reference'
    },
    {
      Header: "Nome",
      accessor: 'productType.friendlyName',
      HeaderColumn: true,
    },
    {
      Header: "Ponto de leitura",
      accessor: 'readpoint.friendlyName'
    },
    {
      Header: "Entrada",
      accessor: 'bizLocationIn.friendlyName'
    },
    {
      Header: "Saída",
      accessor: 'bizLocationOut.friendlyName'
    },
    {
      Header: "Quantidade",
      accessor: 'total'
    },

    {
      Header: "Data",
      accessor: 'date',
      isDate: true,
      Cell: (row) => row.original.date && dayMonthYearAtTimeWithSeconds(row.original.date)
    },
  ]

  customFilterComponent = (_props, _state, onChange) => {
    const handleSetValue = (filterEntity) => {
      return (value) => {
        if (Array.isArray(value)) {
          this.customFilters[filterEntity] = value.map(x => x.id).join(',')
        } else {
          this.customFilters[filterEntity] = value
        }

        onChange && onChange(this.customFilters)
      }
    }

    return (
      <Row>
        <Col md={4}>
          <ProductTypeSelector multiple setValue={handleSetValue('productTypeId')}/>
        </Col>
        <Col md={4}>
          <BizLocationSelector multiple setValue={handleSetValue('bizLocationIdIn')} title="Local de entrada"/>
        </Col>
        <Col md={4}>
          <BizLocationSelector multiple setValue={handleSetValue('bizLocationIdOut')} title="Local de saída"/>
        </Col>
        <Col md={4}>
          <ReadpointSelector multiple setValue={handleSetValue('readpointId')}/>
        </Col>
        <Col md={4}>
          <DateRangeSelector
            onChange={(startDate, endDate) => {
              this.customFilters.startDate = startDate;
              this.customFilters.endDate = endDate;
              onChange({...this.customFilters})
            }}
            defaultStartDate={this.customFilters.startDate}
          />
        </Col>
      </Row>
    )
  }

  endpoint = (_props, {customFilter}) => {
    const filterParams = new URLSearchParams({})
    const {startDate, endDate} = this.customFilters;
    startDate && filterParams.append('startDate', this.customFilters.startDate.toISOString());
    endDate && filterParams.append('endDate', this.customFilters.endDate.toISOString());

    customFilter.bizLocationIdIn && filterParams.append('bizLocationIdIn', this.customFilters.bizLocationIdIn)
    customFilter.bizLocationIdOut && filterParams.append('bizLocationIdOut', this.customFilters.bizLocationIdOut)
    customFilter.readpointId && filterParams.append('readpointId', this.customFilters.readpointId)
    customFilter.productTypeId && filterParams.append('productTypeId', this.customFilters.productTypeId)
    customFilter.dateBegin && filterParams.append('dateBegin', this.customFilters.dateBegin.toISOString())
    customFilter.dateEnd && filterParams.append('dateEnd', this.customFilters.dateEnd.toISOString())

    return `ton/v1/movements/details?${filterParams.toString()}`
  }
}

export default MovedProductsGrid





// WEBPACK FOOTER //
// ./src/customGrid/entities/MovedProductsGrid.js